import { Component, OnInit, inject } from '@angular/core';
import {
  RouterOutlet,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { UserService } from '@app/auth/services/user.service';
import { UtilizadoresService } from '@app/shared/components/api/services/utilizadores.service';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { AuthService } from '@app/auth/services/auth.service';
import { DashboardService } from '@app/shared/components/api/services/dashboard.service';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, CommonModule],
  providers: [UserService, UtilizadoresService, DashboardService],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent implements OnInit {
  utilizador: any;
  initials: string = '';
  sidebarOpen: boolean = false;

  totalCampanhas: number | null = null;
  totalUtilizadores: number | null = null;
  totalPagamentos: number | null = null;
  totalRegistos: number | null = null;

  private readonly userService = inject(UserService);
  private readonly utilizadoresService = inject(UtilizadoresService);
  private readonly dashboardService = inject(DashboardService);
  private readonly messageService = inject(MessageService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.initials = this.userService.getUserInitials() || '';
    this.getUser();
    this.carregarIndicadores();
  }

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  closeSidebar() {
    this.sidebarOpen = false;
  }

  carregarIndicadores() {
    this.dashboardService.getDashboardGeral().subscribe({
      next: (res) => {
        if (res?.data) {
          this.totalCampanhas = res.data.totalCampanhas ?? null;
          this.totalUtilizadores = res.data.totalUtilizador ?? null;
          this.totalPagamentos = res.data.totalApoios ?? null;
          this.totalRegistos = res.data.totalRegistos ?? null;
        }
      },
      error: (err) => {
        console.error('Erro ao carregar indicadores:', err);
      },
    });
  }

  getUser(): void {
    const userId = this.userService.getUserId();
    if (userId) {
      this.utilizadoresService.show(userId).subscribe({
        next: (res) => {
          this.utilizador = res.data;
          if (
            !this.utilizador?.roles.find(
              (role: any) => role.roleName === 'Admin',
            )
          ) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Sem permissão',
              detail: 'Precisa de permissão para aceder a esta página.',
            });
            setTimeout(() => {
              this.router.navigate(['/']);
            }, 250);
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sessão não iniciada',
        detail: 'Por favor inicie sessão.',
      });
      this.router.navigate(['/']);
    }
  }

  logout() {
    const accessToken: string | null = this.authService.getAccessToken();
    if (!accessToken) {
      this.authService.clearSession();
      return;
    }
    this.authService.logout();
  }
}
